export default {
  arrives: 'Ankommer',
  journeyDuration: 'Rejsetid',
}
